import React from 'react';
import { InformationCircleIcon } from '@heroicons/react/24/outline';

import { useTranslation } from 'react-i18next';

export const TicketingSetupCallout: React.FC = () => {
  const { t } = useTranslation('pleri/library');
  return (
    <div className="bg-badge-info-background relative overflow-hidden rounded-2xl px-4 py-3 shadow-sm">
      <div className="relative flex items-center gap-3">
        <div
          aria-hidden="true"
          className="text-severity-informational-base flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full bg-white/80 dark:bg-gray-900/80"
        >
          <InformationCircleIcon className="h-4.5 w-4.5" />
        </div>
        <div>
          <h3 className="text-severity-informational-base text-base font-semibold">
            {t('iNeedAConnectedTicketingToolBefore')}
          </h3>
          <p className="mt-1.5 text-sm text-blue-900">
            {t('iBroughtYouHereBecauseCreateTicket')}
          </p>
        </div>
      </div>
    </div>
  );
};
